import { render, staticRenderFns } from "./RateModalSurvey.vue?vue&type=template&id=89c9927c&scoped=true&"
import script from "./RateModalSurvey.vue?vue&type=script&lang=js&"
export * from "./RateModalSurvey.vue?vue&type=script&lang=js&"
import style0 from "./RateModalSurvey.vue?vue&type=style&index=0&id=89c9927c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c9927c",
  null
  
)

export default component.exports